<div class="slider-wrapper">
    <input *ngIf="!hideInput"
           class="slider-input"
           type="number"
           [value]="minValue"
           [min]="min"
           [max]="max"
           [step]="step"
           [disabled]="disabled"
           (input)="onMinInputChange($event)">
    <mat-slider class="inner-slider"
                [value]="minValue"
                [min]="min"
                [max]="max"
                [step]="step"
                [disabled]="disabled"
                (input)="onSliderChange($event)">
    </mat-slider>
</div>

